import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  declare submitButtonTarget: HTMLButtonElement

  onUploadingChange(event: CustomEvent) {
    const { activeUploads } = event.detail as { activeUploads: number }
    this.submitButtonTarget.disabled = activeUploads > 0
  }
}
